// extracted by mini-css-extract-plugin
module.exports = {"headerText":"index_headerText_31ch5","user":"index_user_1k25S"};